module.exports = __webpack_public_path__ + "static/media/jeans.2926bad2.png";